var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalisis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 683,
    viewBox: "0 0 510 683",
    fill: "#9597A7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.333 20.0013V40.0013H70.6667H0V361.335V682.668H254.667H509.333V361.335V40.0013H438.667H368V20.0013V0.00126648H254.667H141.333V20.0013ZM328 60.0013V80.0013H254.667H181.333V60.0013V40.0013H254.667H328V60.0013ZM141.333 100.001V120.001H254.667H368V100.001V80.0013H418.667H469.333V361.335V642.668H254.667H40V361.335V80.0013H90.6667H141.333V100.001Z",
    fill: "#9597A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.668 241.335V322.668H334.668H314.668V261.335V200.001H294.668H274.668V261.335V322.668H254.668H234.668V281.335V240.001H214.668H194.668V281.335V322.668H174.668H154.668V301.335V280.001H134.668H114.668V301.335V322.668H96.668H78.668V342.668V362.668H254.668H430.668V342.668V322.668H412.668H394.668V241.335V160.001H374.668H354.668V241.335Z",
    fill: "#9597A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.668 422.668V442.668H156.668H234.668V422.668V402.668H156.668H78.668V422.668Z",
    fill: "#9597A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M274.668 422.668V442.668H352.668H430.668V422.668V402.668H352.668H274.668V422.668Z",
    fill: "#9597A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.668 502.668V522.668H156.668H234.668V502.668V482.668H156.668H78.668V502.668Z",
    fill: "#9597A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M274.668 502.668V522.668H352.668H430.668V502.668V482.668H352.668H274.668V502.668Z",
    fill: "#9597A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.668 582.668V602.668H156.668H234.668V582.668V562.668H156.668H78.668V582.668Z",
    fill: "#9597A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M274.668 582.668V602.668H352.668H430.668V582.668V562.668H352.668H274.668V582.668Z",
    fill: "#9597A7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalisis);
export default __webpack_public_path__ + "static/media/analisis.0e5b82b4732ba466bb60d4fcb4a6dcf9.svg";
export { ForwardRef as ReactComponent };